import { getPaymentMethodReserve } from 'apis/payment';
import { CardManagement } from 'components/payment/CardManagement';
import { BaseButton } from 'components/ui/BaseButton';
import { useTranslation } from 'i18n';
import { useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { cardListState } from 'store/atoms';
import styled from 'styled-components';

const CardManagementHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  font-size: 24px;
  font-weight: 800;
  color: #0f0f0f;
  line-height: 150%;
`;
const CardManagementSection = styled.div`
  padding: 0 20px;
`;

const ButtonContainer = styled.div`
  padding: 14px 24px;
  margin-top: auto;
  background-color: #ffffff;
`;

export default function CardManagementPage() {
  const { t } = useTranslation();
  const [cardList] = useRecoilState<any>(cardListState);

  const handleAddCard = async () => {
    try {
      const res: any = await getPaymentMethodReserve();
      window.open(res.data, '_blank');
    } catch {
      console.log('error');
    }
  };

  return (
    <>
      <CardManagementHeader>{t('card.title')}</CardManagementHeader>
      <CardManagementSection>
        <CardManagement management={true} />
      </CardManagementSection>
      {cardList.length > 0 && (
        <ButtonContainer>
          <BaseButton
            text={t('card.cta.add_new')}
            size="large"
            variant="outline"
            onClick={async () => await handleAddCard()}
          />
        </ButtonContainer>
      )}
    </>
  );
}
